import { AxiosInstances as AxiosInstance} from './BaseService'

export default {
    getBySchoolDBN: (locationCode: string) =>
        AxiosInstance({
            'method': 'GET',
            'url': `/Schools/${locationCode}/SchoolInfo`
        })
}